﻿import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ShowHide } from "components/layout";
import { InputGroup, Tooltip, Button, Position } from "@blueprintjs/core";

import { FormHelperText } from "components/form-fields";
import 'components/form-fields/FormFields.css';


export function FormPasswordInput(
    {
        id = null,
        value = "",
        loading = false,
        headingText = null,
        helperText = null,
        disabled = false,
        dangerHelperText = null,
        placeholder = "",
        large = false,
        maxLength = null,
        secureFieldName = null,
        inputRef,
        onChange
    }
) {

    const [showPassword, setShowPassword] = useState(false);

    function onPasswordToggle() {
        setShowPassword(!showPassword);
    }

    let size;
    if (large) {
        size = "large";
    }

    return (
        <div className="form-row">
            <div className="form-field">
                <ShowHide
                    evaluator={headingText != null}
                    show={(
                        <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                    )}
                />
                <FormHelperText loading={loading}>{helperText}</FormHelperText>
                <InputGroup
                    id={id}
                    className={classNames({ "bp6-skeleton": loading })}
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    size={size}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    inputRef={inputRef}
                    type={showPassword ? "text" : "password"}
                    rightElement={(
                        <Tooltip position={Position.RIGHT} content={`${showPassword ? "Hide" : "Show"} ${secureFieldName || "Password"}`}>
                            <Button
                                icon={showPassword ? "unlock" : "lock"}
                                variant="minimal"
                                onClick={onPasswordToggle}
                                tabIndex="-1"
                            />
                        </Tooltip>
                    )}
                />
           
                <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
            </div>
        </div>
    );
}

FormPasswordInput.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    disabled: PropTypes.bool,
    dangerHelperText: PropTypes.node,
    placeholder: PropTypes.string,
    large: PropTypes.bool,
    inputRef: PropTypes.object,
    maxLength: PropTypes.number,
    secureFieldName: PropTypes.string
};